var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNewUserWeekCoins = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 89.1 89.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc466;}.cls-2{fill:#2e63f7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.65,
    y: 61.11,
    width: 43.04,
    height: 8.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.72,
    y: 71.04,
    width: 41.94,
    height: 7.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.55,
    y: 79.87,
    width: 41.94,
    height: 7.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64.42,
    cy: 40.14,
    r: 20.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.55,89.1H86.78a.81.81,0,0,0,.81-.81V79.24a.81.81,0,0,0-.81-.81H78.54V71h9.75a.81.81,0,0,0,.81-.81v-9a.81.81,0,0,0-.81-.81H72.76L75.05,59a21.89,21.89,0,0,0-9.43-40.86l-.65,0V15.19H79.24a.81.81,0,0,0,.81-.81v-6A8.36,8.36,0,0,0,71.7,0H21.93a6.85,6.85,0,0,0-6.85,6.84v5.23H6.84A6.85,6.85,0,0,0,0,18.91v4.52a.81.81,0,0,0,.81.81H6V77.73a6.85,6.85,0,0,0,6.85,6.84H43.74v3.72A.81.81,0,0,0,44.55,89.1ZM36.31,78.43V71H76.93v7.43ZM86,80.05v7.44H45.36V80.05ZM87.49,62v7.43H46.87V62ZM84.47,40h0a20.31,20.31,0,1,1-20.31-20.3A20.33,20.33,0,0,1,84.47,40ZM71.7,1.62a6.74,6.74,0,0,1,6.73,6.73v5.22H65V8.35A6.74,6.74,0,0,1,71.7,1.62Zm-55,5.22a5.24,5.24,0,0,1,5.22-5.22H66.55L65.49,2.79a8.26,8.26,0,0,0-2.14,5.56v9.78l-.66,0a22.38,22.38,0,0,0-3.27.46l-.64.14-.18-.64a8.51,8.51,0,0,0-2.12-3.63,8.32,8.32,0,0,0-5.87-2.43H16.7ZM1.62,22.63V18.91a5.25,5.25,0,0,1,5.22-5.23H45.41l-1,1.17a8.34,8.34,0,0,0-2.13,5.56v2.22ZM12.88,83a5.25,5.25,0,0,1-5.23-5.22V24.24H43a.81.81,0,0,0,.81-.81v-3a6.76,6.76,0,0,1,6.75-6.74h0a6.76,6.76,0,0,1,4.74,2,7.16,7.16,0,0,1,1.72,3l.17.63-.61.22A22,22,0,0,0,44.78,29.8l-.2.37H24.13v1.61H43.86l-.34.94a21.39,21.39,0,0,0-1.07,4.38l-.08.61H24.13v1.61H42.24V40a22.21,22.21,0,0,0,.44,4.38l.17.84H24.13v1.62H43.36l.16.47a21.85,21.85,0,0,0,2.12,4.38l.68,1.07H24.13v1.62H47.65l.21.23A22.66,22.66,0,0,0,53.27,59l2.26,1.3H24.13V62H45.25v7.43H35.5a.81.81,0,0,0-.81.81v9a.81.81,0,0,0,.81.81h8.24V83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.51,46.06V43a3.84,3.84,0,0,0-3.83-3.82H59.63A2.21,2.21,0,0,1,57.43,37V34a2.21,2.21,0,0,1,2.2-2.21h9.05A2.21,2.21,0,0,1,70.89,34v.81h1.62V34a3.84,3.84,0,0,0-3.83-3.82H65v-3H63.35v3H59.63A3.84,3.84,0,0,0,55.81,34v3a3.84,3.84,0,0,0,3.83,3.82h9A2.21,2.21,0,0,1,70.89,43v3a2.21,2.21,0,0,1-2.21,2.21H59.63a2.21,2.21,0,0,1-2.2-2.21v-.81H55.81v.81a3.84,3.84,0,0,0,3.83,3.82h3.71v3H65v-3h3.71A3.84,3.84,0,0,0,72.51,46.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.58,
    y: 30.17,
    width: 4.63,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.58,
    y: 37.71,
    width: 4.63,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.58,
    y: 45.25,
    width: 4.63,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.58,
    y: 52.79,
    width: 4.63,
    height: 1.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.58,
    y: 60.33,
    width: 4.63,
    height: 1.62
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewUserWeekCoins, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/newUserWeekCoins.ab1955c1.svg";
export { ForwardRef as ReactComponent };